<template>
  <div class="p-6 w-1/2 h-full flex flex-col">
    <div v-for="(item, index) in listOfTools" :key="index"
      class="dark:bg-dark-card dark:text-dark-text py-1 px-2 fhd:py-4 fhd:px-6 4k:py-14 4k:px-16 rounded-lg 4k:rounded-2xl font-mono mb-4 shadow-pen w-max bg-dark-card text-dark-text"
      :class="{ 'self-center': index === 0,
        'self-center sm:self-end': index === 1}">
      <div class="flex flex-row my-2 space-x-2">
        <IconCog />
        <h1 class="font-bold text-base fhd:text-xl 4k:text-5xl 4k:py-4 uppercase tracking-widest leading-4 self-center">{{item.name}}</h1>
      </div>

      <ul class="w-full text-li text-gray-200 mb-2 ml-2 mr-3 leading-6">
        <li v-for="(tools, index) in item.list" :key="index" class="4k:py-8"><b>></b> {{ tools }}</li>
      </ul>
    </div>
    <ResumeHobbies />
  </div>
</template>

<script>
import ResumeHobbies from './ResumeHobbies.vue';
export default {
  components: {
    ResumeHobbies,
  },
  data() {
    return {
      listOfTools: [
        {
          name: 'Frontend',
          list: [
            'HTML5 | CSS/SASS/SCSS | JS',
            'Angular +7',
            'VueJS 2',
            'Tailwind CSS',
            'Angular Material | Bulma',
          ],
        },
        {
          name: 'Backend',
          list: [
            'Python | Django',
            'Java',
            'Firebase',
            'Docker | AWS',
            'MySQL',
          ],
        }
      ],
    };
  },
  methods: {
    getHobbiesnList(item) {
      console.log(item);
      return item;
    },
  },
}
</script>

<style scoped>
.shadow-pen {
  box-shadow: 0 4px 30px rgb(0 0 0 / 50%);
}
</style>